module.exports = __webpack_public_path__ + "static/media/remaining_debt_red.f1faf1cd.svg";